import React from 'react'
import { withTranslation } from 'react-i18next'
import { useSessionStorage } from 'react-use-sessionstorage'
import useLocalStorage from 'react-use-localstorage'
import { Link } from 'react-router-dom'
import storage from '../common/utils/storage'

const KEY__ACCEPT_COOKIES = 'COOKIE_BANNER__ACCEPT_COOKIES'
const KEY__IS_OPEN = 'COOKIE_BANNER__IS_OPEN'

const CookiesBanner = ({ t }) => {
    const [acceptCookies, setAcceptCookies] = useLocalStorage(KEY__ACCEPT_COOKIES, 'false')
    const [isOpen, setOpen] = useSessionStorage(KEY__IS_OPEN, 'true')

    if (acceptCookies === 'true' || isOpen === 'false') {
        return null
    }

    return (
        <div className="cookies-banner">
            <p>
                {t('_components._cookies_banner.text_1')} <Link to="/cookie-policy">{t('_common.cookie_policy')}</Link>{' '}
                {t('_components._cookies_banner.and')} <Link to="/privacy-policy">{t('_common.privacy_policy')}</Link>.
            </p>
            <button className="button" data-variant="primary" data-size="md" onClick={() => setAcceptCookies('true')}>
                {t('_components._cookies_banner.accept_cookies')}
            </button>
            {/* <div onClick={() => setOpen('false')}>
                <IconClose />
            </div> */}
        </div>
    )
}

const CookiesBannerWrapper = ({ t }) =>
    window && storage.checkAccess('localStorage') && storage.checkAccess('sessionStorage') ? (
        <CookiesBanner t={t} />
    ) : null

const IconClose = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.92867 1.92893L16.0708 16.0711"
            stroke="#787878"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.0708 1.92893L1.9287 16.0711"
            stroke="#787878"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default withTranslation('translations')(CookiesBannerWrapper)
